/**
 * App → H5 公参白名单。
 * 第一期只有 packageName；后续扩展 channel / appVersion 等时只改这里。
 */
export const APP_COMMON_PARAM_KEYS = ['packageName'] as const;

export type AppCommonParamKey = (typeof APP_COMMON_PARAM_KEYS)[number];

/** 从 localStorage 读取白名单公参（仅非空值） */
export function pickAppCommonParams(storage: Storage = localStorage): Record<string, string> {
  return APP_COMMON_PARAM_KEYS.reduce<Record<string, string>>((ret, key) => {
    const value = storage.getItem(key);
    if (value) {
      ret[key] = value;
    }
    return ret;
  }, {});
}
